// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-container__1p9aH"};